import { OpportunityRow } from "pages/sales-tools/opportunities/models";
import type { SalesProduct } from "pages/sales-tools/opportunities/models";
import { makeApiRequestToUrl } from "utils/api-client";
import { SalesSearchOrganisation } from "./models";

async function fetchSalesOpportunities(): Promise<OpportunityRow[]> {
  try {
    const response = await makeApiRequestToUrl(
      `${import.meta.env.VITE_DELIVERY_API_URL}`,
      `/sales/opportunities`,
      "GET",
    );

    const responseData = await response.json();

    if (response.status !== 200) {
      throw new Error(responseData.detail || "Failed to fetch opportunities");
    }

    return responseData;
  } catch (err) {
    throw new Error(`Unable to fetch admin opportunities: ${err}`);
  }
}

async function fetchSalesOpportunity(oppId: string): Promise<OpportunityRow> {
  try {
    const response = await makeApiRequestToUrl(
      `${import.meta.env.VITE_DELIVERY_API_URL}`,
      `/sales/opportunities/${oppId}`,
      "GET",
    );

    const responseData = await response.json();

    if (response.status !== 200) {
      throw new Error(responseData.detail || "Failed to fetch opportunity");
    }

    return responseData;
  } catch (err) {
    throw new Error(`Unable to fetch admin opportunity '${oppId}': ${err}`);
  }
}

async function fetchOrganisationsSalesSearch(
  query: string,
): Promise<SalesSearchOrganisation[]> {
  try {
    const response = await makeApiRequestToUrl(
      `${import.meta.env.VITE_DELIVERY_API_URL}`,
      `/sales/organisation/search?query=${encodeURIComponent(query)}`,
      "GET",
    );
    const responseData = await response.json();

    if (response.status !== 200) {
      throw new Error(responseData.messages.join(". "));
    }

    return responseData;
  } catch (err) {
    throw new Error(
      `Unable to fetch organisations with query '${query}' : ${err}`,
    );
  }
}

async function fetchSalesProducts(): Promise<SalesProduct[]> {
  try {
    const response = await makeApiRequestToUrl(
      `${import.meta.env.VITE_DELIVERY_API_URL}`,
      `/sales/products`,
      "GET",
    );

    const responseData = await response.json();

    if (response.status !== 200) {
      throw new Error(responseData.detail || "Failed to fetch products");
    }

    return responseData;
  } catch (err) {
    throw new Error(`Unable to fetch sales products: ${err}`);
  }
}

export {
  fetchSalesOpportunities,
  fetchSalesOpportunity,
  fetchOrganisationsSalesSearch,
  fetchSalesProducts,
};
